import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=5c53fa9d&scoped=true&"
import script from "./VideoPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=5c53fa9d&prod&lang=sass&scoped=true&"
import style1 from "./VideoPlayer.vue?vue&type=style&index=1&id=5c53fa9d&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c53fa9d",
  null
  
)

export default component.exports